const CART_KEY = 'raikCart';
let cart = [];

const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);

const getStoredCart = () => {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch {
    return [];
  }
};

const persistCart = () => {
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
};

const updateCartCount = () => {
  const count = cart.reduce((sum, item) => sum + item.qty, 0);
  document.querySelectorAll('.cart-count').forEach((badge) => {
    badge.textContent = count;
  });
};

const showToast = (message) => {
  const toast = document.createElement('div');
  toast.className = 'cart-toast';
  toast.textContent = message;
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('visible'));
  setTimeout(() => {
    toast.classList.remove('visible');
    toast.addEventListener('transitionend', () => toast.remove(), {
      once: true,
    });
  }, 2200);
};

const addToCart = (item) => {
  const existing = cart.find(
    (entry) => entry.id === item.id && entry.size === item.size
  );
  if (existing) {
    existing.qty += item.qty;
  } else {
    cart.push(item);
  }
  persistCart();
  updateCartCount();
  renderCartPage();
  showToast('Added to cart ✨');
};

const updateCartTotals = () => {
  const subtotal = cart.reduce((sum, item) => sum + item.price * item.qty, 0);
  const subtotalEl = document.getElementById('cart-subtotal');
  const totalEl = document.getElementById('cart-total');
  if (subtotalEl) subtotalEl.textContent = formatCurrency(subtotal);
  if (totalEl) totalEl.textContent = formatCurrency(subtotal);
};

const bindCartRowEvents = () => {
  document.querySelectorAll('.qty-minus').forEach((btn) =>
    btn.addEventListener('click', () => {
      const index = Number(btn.dataset.index);
      if (cart[index]) {
        cart[index].qty = Math.max(1, cart[index].qty - 1);
        persistCart();
        renderCartPage();
      }
    })
  );
  document.querySelectorAll('.qty-plus').forEach((btn) =>
    btn.addEventListener('click', () => {
      const index = Number(btn.dataset.index);
      if (cart[index]) {
        cart[index].qty += 1;
        persistCart();
        renderCartPage();
      }
    })
  );
  document.querySelectorAll('.remove-item').forEach((btn) =>
    btn.addEventListener('click', () => {
      const index = Number(btn.dataset.index);
      cart.splice(index, 1);
      persistCart();
      renderCartPage();
      updateCartCount();
    })
  );
};

const renderCartPage = () => {
  const container = document.getElementById('cart-items');
  if (!container) return;

  if (!cart.length) {
    container.innerHTML = `
      <div class="empty-cart">
        <p>Your bag is empty—time to get that lift!</p>
        <a class="btn btn-primary" href="product.html">Shop B-FIRM</a>
      </div>
    `;
    updateCartTotals();
    return;
  }

  container.innerHTML = cart
    .map(
      (item, index) => `
        <article class="cart-item">
          <img src="${item.image}" alt="${item.name}" />
          <div class="cart-item-details">
            <h4>${item.name}</h4>
            <p>${item.size}</p>
            <p>${formatCurrency(item.price)} each</p>
          </div>
          <div class="cart-item-actions">
            <div class="qty-control">
              <button class="qty-minus" data-index="${index}" aria-label="Decrease quantity">-</button>
              <span>${item.qty}</span>
              <button class="qty-plus" data-index="${index}" aria-label="Increase quantity">+</button>
            </div>
            <strong>${formatCurrency(item.price * item.qty)}</strong>
            <button class="remove-item" data-index="${index}">Remove</button>
          </div>
        </article>
      `
    )
    .join('');

  updateCartTotals();
  bindCartRowEvents();
};

const handleVariantSelection = () => {
  const pills = document.querySelectorAll('.variant-pill');
  const priceEl = document.getElementById('product-price');
  const compareEl = document.getElementById('product-compare');
  if (!pills.length) return;

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      pills.forEach((btn) => {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('active');
      pill.setAttribute('aria-pressed', 'true');
      if (priceEl) {
        priceEl.dataset.price = pill.dataset.price;
        priceEl.textContent = formatCurrency(Number(pill.dataset.price));
      }
      if (compareEl) {
        const comparePrice =
          Number(pill.dataset.price) * 1.2; /* simple comparison */
        compareEl.textContent = formatCurrency(comparePrice);
      }
    });
  });
};

const handleAddToCartButton = () => {
  const button = document.querySelector('.add-to-cart');
  if (!button) return;
  const qtyInput = document.getElementById('qty');
  const section = document.querySelector('.product-hero');

  button.addEventListener('click', () => {
    const variant = document.querySelector('.variant-pill.active');
    const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));

    if (!section || !variant) return;

    const price = Number(variant.dataset.price);
    const item = {
      productId: section.dataset.productId,
      id: `${section.dataset.productId}-${variant.dataset.size}`,
      name: section.dataset.productName,
      size: variant.dataset.size,
      price,
      qty,
      image: section.dataset.productImage,
    };

    addToCart(item);
  });
};

const initContactForm = () => {
  const form = document.querySelector('.contact-form');
  if (!form) return;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    form.reset();
    showToast('Message sent! We will reply within 24h.');
  });
};

const initNewsletterForm = () => {
  const form = document.querySelector('.newsletter-form');
  if (!form) return;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    form.reset();
    showToast('Welcome to the glow list ✨');
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const yearSpan = document.getElementById('year');
  if (yearSpan) {
    yearSpan.textContent = new Date().getFullYear();
  }

  cart = getStoredCart();
  updateCartCount();
  renderCartPage();
  handleVariantSelection();
  handleAddToCartButton();
  initContactForm();
  initNewsletterForm();
});

